
export const toggleStatus = (callback, status) => {
	callback(!status);
}
